export default "__VITE_ASSET__Xj1zPQT3__"